export function decodeJwt(token) {
    try {
        const payload = token.split(".")[1];
        if (!payload)
            return null;
        const decoded = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
        return JSON.parse(decoded);
    }
    catch {
        return null;
    }
}
export function isExpired(token) {
    const payload = decodeJwt(token);
    if (!payload || typeof payload.exp !== "number")
        return true;
    return payload.exp * 1000 < Date.now();
}
